<h1 mat-dialog-title>Reset</h1>
<div mat-dialog-content>
  <form [formGroup]="formData" (ngSubmit)="confirm()">
    <mat-form-field class="status-msg-input">
      <mat-label>{{ broadcast.config.awayConfig.shortName }} pitch count:</mat-label>
      <input matInput type="number" formControlName="awayPitches">
      <button *ngIf="isSet('awayPitches')" matSuffix mat-icon-button aria-label="Clear" (click)="clear('awayPitches')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field class="status-msg-input">
      <mat-label>{{ broadcast.config.homeConfig.shortName }} pitch count:</mat-label>
      <input matInput type="number" formControlName="homePitches">
      <button *ngIf="isSet('homePitches')" matSuffix mat-icon-button aria-label="Clear" (click)="clear('homePitches')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </form>
  <div class="count-control">
    <label>Balls:</label>
    <button mat-stroked-button [class.selected]="this.broadcast.manualData.balls === 0" (click)="this.broadcast.manualData.balls = 0">0</button>
    <button mat-stroked-button [class.selected]="this.broadcast.manualData.balls === 1" (click)="this.broadcast.manualData.balls = 1">1</button>
    <button mat-stroked-button [class.selected]="this.broadcast.manualData.balls === 2" (click)="this.broadcast.manualData.balls = 2">2</button>
    <button mat-stroked-button [class.selected]="this.broadcast.manualData.balls === 3" (click)="this.broadcast.manualData.balls = 3">3</button>
  </div>
  <div class="count-control">
    <label>Strikes:</label>
    <button mat-stroked-button [class.selected]="this.broadcast.manualData.strikes === 0" (click)="this.broadcast.manualData.strikes = 0">0</button>
    <button mat-stroked-button [class.selected]="this.broadcast.manualData.strikes === 1" (click)="this.broadcast.manualData.strikes = 1">1</button>
    <button mat-stroked-button [class.selected]="this.broadcast.manualData.strikes === 2" (click)="this.broadcast.manualData.strikes = 2">2</button>
  </div>
  <div class="count-control">
    <label>Outs:</label>
    <button mat-stroked-button [class.selected]="this.broadcast.manualData.outs === 0" (click)="this.broadcast.manualData.outs = 0">0</button>
    <button mat-stroked-button [class.selected]="this.broadcast.manualData.outs === 1" (click)="this.broadcast.manualData.outs = 1">1</button>
    <button mat-stroked-button [class.selected]="this.broadcast.manualData.outs === 2" (click)="this.broadcast.manualData.outs = 2">2</button>
  </div>
  <div class="count-control runners">
    <label>Runners:</label>
    <button class="third" mat-stroked-button [class.selected]="this.broadcast.manualData.third" (click)="this.broadcast.manualData.third = !this.broadcast.manualData.third"><div>3</div></button>
    <button class="second" mat-stroked-button [class.selected]="this.broadcast.manualData.second" (click)="this.broadcast.manualData.second = !this.broadcast.manualData.second"><div>2</div></button>
    <button class="first" mat-stroked-button [class.selected]="this.broadcast.manualData.first" (click)="this.broadcast.manualData.first = !this.broadcast.manualData.first"><div>1</div></button>
  </div>
  <p>If you don't wish pitch counts to be displayed, set them to empty value.</p>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button (click)="close()">Close</button>
  <button mat-stroked-button (click)="confirm()" cdkFocusInitial>Confirm</button>
</div>
